import React, { Fragment, useEffect, useState } from 'react';
import './i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AppRoutes from './routes/AppRoutes';

import { useUsers } from './hooks/useUsers'; 
import { UserProvider } from './context/UserContext'; 

import LanguageSwitcher from './components/LanguageSwitcher';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Spinner from './features/Spinner';
import OnboardingModal from './features/Onboarding/OnboardingModal';
import { updateOnboarding } from './redux/auth/authSlice';

import { useSelector, useDispatch } from 'react-redux';
import { checkAuth, isOnboardingCompleted } from './redux/auth/authSlice';
import { loadCookieConsent } from './redux/cookie/cookieConsentSlice';
import CookieConsentBanner from './components/CookieConsentBanner';
import { useAuthGuard } from './hooks/useAuthGuard';
import { injectStore } from './api/axios';
import store from './redux/store';

injectStore(store);

const useShouldShowOnboarding = () => {
  const user = useSelector(state => state.auth.user);
  const onboardingCompleted = useSelector(isOnboardingCompleted);
  return !!user && !onboardingCompleted;
};

const App = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { user, loading, authLoaded, authLoading, userProfile } = useSelector((state) => state.auth);
  const { users, loading: usersLoading } = useUsers(userProfile, user);


  const { isConsentGiven } = useSelector((state) => state.cookieConsent);


  const showOnboarding = useShouldShowOnboarding();

  //Run once to check if user is logged in
  useEffect(() => {
    dispatch(checkAuth());
    dispatch(loadCookieConsent());
  }, [dispatch]);
  

  useAuthGuard({ 
    user, 
    authLoaded, 
    authLoading, 
    location, 
    navigate
  });
  console.log("App.js", {
    authLoaded,
    authLoading,
    loading
  })
  // ⏳ Wait for auth check to complete
  if(!authLoaded || authLoading || loading) return <Spinner fullscreen />;

  console.log("App.js", {
    user: user,
    showOnboarding: showOnboarding
  })

  return (
    <Fragment>
      <LanguageSwitcher />
      <UserProvider initialUsers={users}>
      <Navbar />
      {showOnboarding && (
      <OnboardingModal
          show={showOnboarding}
          onComplete={async() => {
            //await dispatch(checkAuth()).unwrap();
            //setShowOnboarding(false);
            dispatch(updateOnboarding({ onboardingCompleted: true }))
          }}
        />
      )}
      <AppRoutes />
      <div>
        <CookieConsentBanner />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
      />
      <Footer />
      </UserProvider>
    </Fragment>
  );
};
export default App;